$(document).ready(function () {
    enableMoreDiv = true;
    if (IsMobile.any()) {
        $(".customer-support-mobile").css("display", "inline-block");
        $(".contact_mobile_link").css("display", "inline-block");
    } else {
        $(".customer-support-desktop").css("display", "inline-block");
        $(".contact_desktop_link").css("display", "inline-block");
    }

    var formHeight = $('.content_box').outerHeight(true);
    $("#searchForm").css("margin-bottom", "20px");

     $("#service-partner-footer-city-or-zip-code").keyup(function(event){
         if (event.keyCode == 13) {
             $("#service-partner-footer-search-submit").click();
         }
     });

    $("#quick-newsletter-email").keyup(function(event) {
        if (event.keyCode == 13) {
            $("#quick-newsletter-submit-button-lite").click();
        }
    });

    $("#contact-data").hide();
    $("#identification-number-data").hide();
    $("#contact-header").on('click', function() {
        $("#contact-data").toggle();
        $("#identification-number-data").toggle();
    });

    $("#payment-header").on('click', function() {
        var paymentContent = $("#payment-content");
        if (paymentContent.is(':visible')) {
            $("#payment-content").hide();
        } else {
            $("#payment-content").show();
        }
    });

    $("#checkoutRegisterForm").submit(function() {
        $('#btnSubmit').attr('disabled', true);
    });
});